function isBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    var Sys = {};
    var s;

    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :

        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :

            (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :

                (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :

                    (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

    if (Sys.firefox) {//Js判断为火狐(firefox)浏览器
        var localStorageMock = (function (win) {
            var storage = win.localStorage; // 用闭包实现局部对象storage 
            return {
                setItem: function (key, value) {
                    var setItemEvent = new Event("setItemEvent");
                    var oldValue = storage[key];
                    setItemEvent.key = key;
                    if (oldValue != value) { // 判断新旧值，新值更新
                        setItemEvent.newValue = value;
                        setItemEvent.oldValue = oldValue;
                        win.dispatchEvent(setItemEvent);
                        storage[key] = value;
                        return true;
                    }
                },
                getItem: function (key) {
                    return storage[key];
                },
                removeItem: function (key) {
                    storage[key] = null;
                    return true;
                },
                clear: function () {
                    storage.clear();
                    return true;
                }
            };
        }(window));
        Object.defineProperty(window, 'localStorage', {
            value: localStorageMock,
            writable: true,
        })

    } else {
        const signSetItem = localStorage.setItem
        localStorage.setItem = function (key, val) {
            let setEvent = new Event('setItemEvent')
            setEvent.key = key
            setEvent.newValue = val
            window.dispatchEvent(setEvent)
            signSetItem.apply(this, arguments)
        }
    }



}
isBrowser();